import { ApiEndpointHandler } from '@sonar-software/sonar-http';
import { deleteInitiatives } from './deleteInitiatives';

export type DeleteInitiativeByIdRequest = {
	id: number;
};

export const deleteInitiativeById: ApiEndpointHandler<DeleteInitiativeByIdRequest> = (request) =>
	deleteInitiatives({
		initiativeIds: [ request.id ]
	});
